import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { MessageComposeComponent } from './message-compose.component';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CanDeactivateMessageComposeGuard implements CanDeactivate<MessageComposeComponent> {
  canDeactivate(component: MessageComposeComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): boolean | Observable<boolean> {
    return component.canDeactivate();
  }
}